import { ActionSet, createActionSet } from '@futrli/shared-services';

export const GET_CURRENT_AUTHENTICATED_USER: ActionSet = createActionSet('GET_CURRENT_AUTHENTICATED_USER');
export const UPDATE_USER_ATTRIBUTES: ActionSet = createActionSet('UPDATE_USER_ATTRIBUTES');
export const VERIFY_USER_ATTRIBUTES: ActionSet = createActionSet('VERIFY_USER_ATTRIBUTES');
export const VERIFY_USER_ATTRIBUTES_SUBMIT: ActionSet = createActionSet('VERIFY_USER_ATTRIBUTES_SUBMIT');
export const SET_PREFERRED_MFA_TYPE: ActionSet = createActionSet('SET_PREFERRED_MFA_TYPE');
export const STORE_USER_ATTRIBUTES = 'STORE_USER_ATTRIBUTES';
export const STORE_PREFERRED_MFA_TYPE = 'STORE_PREFERRED_MFA_TYPE';
export const STORE_UNAUTHENTICATED_USER = 'STORE_UNAUTHENTICATED_USER';
export const UPDATE_CURRENT_AUTHENTICATED_USER = 'UPDATE_CURRENT_AUTHENTICATED_USER';
export const PROVIDER = 'Futrli';

export const CUSTOM_ATTRIBUTES = {
  PREFIX: 'custom:',
  SIGNUP_DOMAIN: 'custom:signupdomain',
  SIGNUP_PRODUCT: 'custom:signupproduct',
  BUSINESS_PHONE_NUMBER: 'custom:business_phone',
  BUSINESS_TYPE: 'custom:business_type'
};
